import { seriesList } from "@/mocks/tracking";

const toneStyle: Record<string, { block: string; tag: string; icon: string }> = {
  primary: { block: "bg-mark-soft", tag: "text-mark-text", icon: "ri-folder-2-fill" },
  gold: { block: "bg-gold-soft", tag: "text-gold-text", icon: "ri-folder-2-fill" },
  paper: { block: "bg-soft", tag: "text-muted", icon: "ri-folder-2-fill" },
};

export default function Collections() {
  return (
    <section id="series" className="w-full border-b border-line">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-gold-text">
              Themed Packs
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-ink md:text-3xl">
              专题合集 · 把散料串起来看
            </h2>
            <p className="mt-2 text-sm text-muted">
              单条黑料易上头，串成专题才好理解前因后果。按题材整理的背景梳理合集，方便顺着看下去。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {seriesList.map((s) => {
            const t = toneStyle[s.tone];
            return (
              <a
                key={s.name}
                href="#expose"
                className="group flex flex-col rounded-lg border border-line bg-card p-5 transition-colors hover:border-gold/50 hover:bg-cream"
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-9 w-9 items-center justify-center rounded-md ${t.block} ${t.tag}`}
                  >
                    <i className={`${t.icon} text-lg`}></i>
                  </span>
                  <span className="text-xs text-faint">{s.reads}</span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-ink md:text-lg">
                  {s.name}
                </h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-muted md:text-sm">
                  {s.desc}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-line pt-3">
                  <span className="rounded-full bg-soft px-2 py-0.5 text-[11px] text-muted">
                    {s.count} 篇整理
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-mark-text group-hover:text-mark-deep">
                    进入专题 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}